import { createColorGetter, } from '@haaretz/htz-css-tools';
import colors from '../consts/colors';

const getColor = createColorGetter(colors);

export default getColor;
